import _ from 'lodash';
import { useMemo } from 'react';

const useDispatchToActions = (actions, dispatch) => {
  const dispatchToActions = useMemo(() => {
    const mappedValues = _.mapValues(actions, (fn) => (...args) => fn(...args)(dispatch));
    return mappedValues;
  }, [dispatch]);

  return dispatchToActions;
};

export default useDispatchToActions;
